document.addEventListener('DOMContentLoaded', () => {
  /**
   * Read more description toggle.
   */
  const button = document.querySelector('[js-description="read_more"]');

  button?.addEventListener('click', () => {
    button.classList.toggle('is-active');
    document.querySelector('[js-description="short"]').classList.toggle('hidden');
    document.querySelector('[js-description="full"]').classList.toggle('hidden');
    button.querySelector('[js-description="read_more_label"]').classList.toggle('hidden');
    button.querySelector('[js-description="read_less_label"]').classList.toggle('hidden');
  });

  /**
   * Gift wrap option.
   */
  function updateProductGiftWrap() {
    const wrapper = document.querySelector('[js-gift-wrap="product-component"]');
    if (!wrapper) return;
    const productElement = wrapper.querySelector('[js-gift-wrap="product"]');
    const containerElement = wrapper.querySelector('[js-gift-wrap="container"]');
    const giftWrapSpan = document.querySelector('[js-product-form="gift-wrap"]');
    const variantElements = wrapper.querySelectorAll('[js-gift-wrap="variant"]');
    const anyVariantActive = Array.from(variantElements).some((variant) => {
      const checkbox = variant.querySelector('[js-gift-wrap-cart="checkbox"]');
      return checkbox && checkbox.checked;
    });

    if (!anyVariantActive) {
      containerElement?.removeAttribute('open');
      productElement?.setAttribute('aria-expanded', 'false');
      productElement?.classList.remove('hidden');
      productElement?.querySelector('[data-icon="minus"]')?.classList.add('hidden');
      productElement?.querySelector('[data-icon="plus"]')?.classList.remove('hidden');
    }

    productElement?.classList.toggle('hidden', anyVariantActive);
    giftWrapSpan?.classList.toggle('hidden', !anyVariantActive);

    variantElements.forEach((element) => {
      const checkbox = element.querySelector('[js-gift-wrap-cart="checkbox"]');
      const subtitle = element.querySelector('[js-gift-wrap="price"]');

      if (checkbox) {
        checkbox.disabled = anyVariantActive && !checkbox.checked;
        element.classList.toggle('is-active', checkbox.checked);
        element.classList.toggle('hidden', anyVariantActive && !checkbox.checked);
        if (!anyVariantActive) element.classList.remove('hidden');

        if (subtitle) {
          subtitle.textContent = checkbox.checked
            ? `+ ${subtitle.textContent.replace(/^\+\s*/, '').trim()}`
            : subtitle.textContent.replace(/^\+\s*/, '').trim();
        }
      }
    });

    if (variantElements.length === 1 && !productElement) {
      const singleVariant = variantElements[0];
      const checkbox = singleVariant.querySelector('[js-gift-wrap-cart="checkbox"]');

      if (checkbox) singleVariant.classList.toggle('is-active', checkbox.checked);
    }
  }

  document.querySelectorAll('[js-gift-wrap-cart="checkbox"]').forEach((checkbox) => {
    checkbox.addEventListener('change', () => {
      updateProductGiftWrap();
    });
  });
});
